import { useGate, useStore } from 'effector-react'
import {
  WorkSchedule,
  workScheduleModel,
  LoadingBlock,
} from '~/features/WorkSchedule'
import { $paymentSchedule } from '~/features/WorkSchedule/model'
import { NotFound } from '~/shared/ui/NotFound'
import { PageContainer } from '~/shared/ui/PageContainer'

export function WorkSchedulePage() {
  useGate(workScheduleModel.Gate)

  const paymentSchedule = useStore($paymentSchedule)
  const isLoading = useStore(workScheduleModel.getPaymentScheduleFx.pending)

  if (!paymentSchedule && !isLoading) {
    return <NotFound message='Не удалось загрузить график списаний' />
  }

  return (
    <PageContainer canBack backTitle='График списаний' title='График списаний'>
      {isLoading ? <LoadingBlock /> : <WorkSchedule />}
    </PageContainer>
  )
}
